import React from 'react';

import styles from './ThankYou.module.scss';
import ClappingHandsIcon from '@icons/clappingHands.svg';

export interface IProps {
  title?: string | JSX.Element;
  text?: string;
}

export const ThankYou: React.FC<IProps> = ({
  title = 'Thanks for contacting us.',
  text = 'We will answer your request shortly.',
}) => (
  <div className={styles.wrapper}>
    <div className={styles.check}>
      <ClappingHandsIcon className={styles.handsIcon} />
    </div>
    <div>
      <strong className={styles.title}>{title}</strong>
      <span className={styles.text}>{text}</span>
    </div>
  </div>
);
